import { useCallback } from 'react'
import { Copy } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@/utils/cn'

type Props = {
  taskId: number
  className?: string
}

export function GestorDashboardTaskIdChip({ taskId, className }: Props) {
  const copyId = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(String(taskId))
      toast.success(`ID ${taskId} copiado`)
    } catch {
      toast.error('Não foi possível copiar o ID')
    }
  }, [taskId])

  return (
    <button
      type='button'
      title='Clique para copiar o ID da tarefa'
      onClick={(event) => {
        event.stopPropagation()
        void copyId()
      }}
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-[var(--glass-border)] bg-[var(--glass-bg)] px-1.5 py-0.5 text-[11px] font-medium tabular-nums text-accent hover:bg-accent/10',
        className,
      )}
    >
      <Copy size={11} aria-hidden />
      #{taskId}
    </button>
  )
}

export function GestorDashboardTaskLink({
  taskId,
  label,
  className,
  onOpen,
}: {
  taskId: number | null
  label: string
  className?: string
  onOpen: (taskId: number) => void
}) {
  if (!taskId) {
    return <span className={cn('truncate text-text-primary', className)}>{label}</span>
  }

  return (
    <div className={cn('flex min-w-0 items-center gap-2', className)}>
      <button
        type='button'
        onClick={() => onOpen(taskId)}
        className='min-w-0 truncate text-left text-text-primary hover:text-accent'
        title='Ver detalhes da tarefa'
      >
        {label}
      </button>
      <GestorDashboardTaskIdChip taskId={taskId} />
    </div>
  )
}
